module.exports = __webpack_public_path__ + "assets/img/businesses.789a561d.jpg";